import * as React from "react";
import { ContextStore } from "../../../../../../../react-core/Flux/Variables";
import TableFilterDropdown from "../../../../../../../react-core/Html/Components/TableFilterDropdown";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { ContextType } from "../../../../../../../Wrap/Constants/Enums/ContextType";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { AssetClassType } from "../../../../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { ViewType } from "../../../../../../../Wrap/Mapping/PortfolioAnalysis/Investment/Enum/ViewType";
import { AssetClassInstrumentWeighting } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/AssetClassInstrumentWeighting";
import { Investment } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/Investment";
import { ExcelExportAction } from "../../../../../../Shared/ExcelExport/Actions/ExcelExportAction";
import { ExcelExportButton } from "../../../../../../Shared/ExcelExport/ExcelExportButton";
import { LoadingSkeletonType } from "../../../../../../Shared/LoadingSkeleton/Contents";
import { LoadingSkeletonWrapper } from "../../../../../../Shared/LoadingSkeleton/LoadingSkeletonWrapper";
import { TableColSettingsAction } from "../../../../../../Shared/TableColFilter/Action/Action";
import { defaultTableColEditor, TableColSettingKeys } from "../../../../../../Shared/TableColFilter/Resource/Content";
import { TableColSettingsStore } from "../../../../../../Shared/TableColFilter/Store/Variable";
import { TableColEditor } from "../../../../../../Shared/TableColFilter/TableColEditor";
import { AsAtDatePicker } from "../../../../../Common/AsAtDatePicker";
import { InvestmentsAction } from "./Action/InvestmentAction";
import { InvestmentsColConfig } from "./Resource/Contents";
import { InvestmentsStore, ModelUnderlyingInvestmentsStore } from "./Store/Variable";
import { ViewTypeArray, ViewTypeMap, AssetClassTypeArray, AssetClassTypeMap } from "../../Resource/Contents";
import { IPortfolioDashboardComponentProps, PortfolioDashboardComponent } from "../Common/PortfolioDashboardComponent";
import { PresentationContext } from "../Common/PresentationViewWrapper";
import { PresentationViewButton } from "../Common/PresentationViewButton";
import { InvestmentTable } from "./InvestmentTable";
import CoachMarker from "../../../../../../Shared/CoachMarkers/CoachMarker";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";
import { UserStore } from "../../../../../Stroes/Variable";
import { InvestmentsColumns } from "../../../../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/InvestmentsColumns";
import { InvestmentsColumnSetting } from "../../../../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/InvestmentsColumnSetting";
import { selectedHeadAccounts } from "../Common/PortfolioDashboardHelper";
import { PortfolioDashboardMultiSelectionStore, PortfolioDashboardStore } from "../../Store/Variable";
import { ServiceProposition } from "../../../../../../../Wrap/Constants/Enums/ServiceProposition";
import AdviserSiteTagManager, {
    eventCategoryForGTM,
} from "../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { HierarchyLevelName } from "../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import { Urls } from "../../../../../Urls";
import { portfolioDashboardTabEnum } from "../../Resource/Content";
import {IInvestmentTableData, IInvestmentWithToggle, IProductTableData, IInvestmentGroup} from "./Store/InvestmentsStatic";
import { DepositProduct } from "../../../../../../../Wrap/Models/Domains/Investment/DepositProduct";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { DepositProductsQuery } from "../../../../../../../Wrap/Models/Domains/Investment/DepositProductsQuery";
import { InvestmentSelectionAction } from "../../../../../../Shared/IST/Action/InvestmentSelectionAction";
import { ResultPageModel } from "../../../../../../../Wrap/Core/SortingAndPaging/Models/ResultPageModel";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";

interface IPortfolioDashboardInvestmentState {
    userInfo: User;
    tier: AssetClassType;
    asAt: Date;
    view: ViewType;
    data: IInvestmentTableData;
    isLoading: boolean;
    isOpenFilter: boolean;
    toggleFilter: any;
    filter: { view: ViewType; tier: AssetClassType };
    colsettings?: InvestmentsColumnSetting[];
    accountViewSelected: string[];
    cashProducts: Record<number, DepositProduct>;
}

interface IPortfolioDashboardInvestmentProps extends IPortfolioDashboardComponentProps {}

export class PortfolioDashboardInvestment extends PortfolioDashboardComponent<
    IPortfolioDashboardInvestmentProps,
    IPortfolioDashboardInvestmentState
> {
    constructor(props: IPortfolioDashboardInvestmentProps) {
        super(props);
        this.subscribeToStore(InvestmentsStore, () => this.onInvestmentStoreChange());
        this.subscribeToStore(TableColSettingsStore, () => this.onTableColSettingsStoreChange());
        this.subscribeToStore(ModelUnderlyingInvestmentsStore, () => this.onModelUnderlyingInvestmentStoreChange());
    }

    componentDidMount() {
        super.componentDidMount();
        const indexIsBtnPresentationClicked = Object.keys(portfolioDashboardTabEnum).indexOf(
            portfolioDashboardTabEnum.Investments
        );
        if (this.props.isBtnPresentationClicked[indexIsBtnPresentationClicked]) {
            this.props.onPresentationViewStatusChange(
                portfolioDashboardTabEnum.Investments,
                this.props.isBtnPresentationClicked
            );
        } else {
            this.addEvent({
                environment: {
                    appType: "web",
                    setting: "prod",
                    timestamps: JsonDateParser.toJsonDateNoOffset(new Date()).toString(),
                },
                page: {
                    pageUrl: Urls.get()
                        .main.PortfolioDashboard({
                            hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                HierarchyLevelName.Customer,
                                this.props.customerid
                            ),
                        })
                        .investments.getUrl(),
                    pageTitle: `${document.title} - client - investments`,
                },
                user: {
                    loginId: UserStore.getUserInfo()?.ClientId.toString(),
                    internal: "yes",
                },
                event: "pageLoaded",
            });
        }
    }

    onModelUnderlyingInvestmentStoreChange(): void {
        const investments = ModelUnderlyingInvestmentsStore.getData();
        const { data } = this.state;

        let updated = false;
        for (const [key, value] of investments.entries()) {
            const targetModelInvestment =
                data.data[value.product].ModelPortfolioInvestments.data[0].Investments[value.index];
            if (
                targetModelInvestment.InstrumentCode == key &&
                (!targetModelInvestment.sub || targetModelInvestment.sub.length == 0)
            ) {
                updated = true;
                targetModelInvestment.sub = value.underlyings.map((ele) => {
                    return {
                        AssetClass: ele.AssetClass,
                        Investments: this.addToggle(ele.Investments, []),
                        total: this.getTotal(ele.Investments),
                    };
                });
            }
            if (updated) {
                this.setState({ data: data });
            }
        }
    }

    private initTotal() {
        return {
            Difference: { Amount: 0, Currency: CurrencyCode.GBP },
            Allocation: 0,
            TotalCost: { Amount: 0, Currency: CurrencyCode.GBP },
            MarketValue: { Amount: 0, Currency: CurrencyCode.GBP },
            InstrumentWeight: 0,
        };
    }

    private getTotal(data: any[]) {
        const total = this.initTotal();
        data.forEach((ele) => {
            total.Difference.Amount += ele.Difference.Amount;
            total.Allocation += ele.Allocation;
            total.TotalCost.Amount += ele.TotalCost.Amount;
            total.MarketValue.Amount += ele.MarketValue.Amount;
            total.InstrumentWeight += ele.InstrumentWeight;
        });
        return total;
    }

    private addToggle(
        data: Investment[],
        InstrumentWeighting: AssetClassInstrumentWeighting[]
    ): IInvestmentWithToggle[] {
        return data.map((ele) => {
            const filterObj = InstrumentWeighting.filter((weight) => weight.InstrumentCode === ele.InstrumentCode);
            const weight = filterObj && filterObj.length > 0 ? filterObj[0].Weighting : 0;
            return { isToggle: false, sub: null, ...ele, InstrumentWeighting: weight, isTreasuredAssets: false };
        });
    }

    onTableColSettingsStoreChange() {
        const data = TableColSettingsStore.getData();
        const colEditorKey = TableColSettingKeys.Investments;
        if (JSON.stringify(data) == "{}") {
            TableColSettingsAction.post(defaultTableColEditor);
        } else if (data[colEditorKey].length == 0) {
            TableColSettingsAction.post(defaultTableColEditor[colEditorKey], colEditorKey);
        } else {
            const allWrapAccount = selectedHeadAccounts(
                PortfolioDashboardMultiSelectionStore.getData(),
                PortfolioDashboardStore.getData()
            )?.every((acc) => acc?.AccountServicePropositionId == ServiceProposition.Wrap);
            if (this.state.view == ViewType.Asset || !allWrapAccount) {
                data[colEditorKey] = data[colEditorKey].filter(
                    (ele) => ele?.Column != InvestmentsColumns.TreasuredAsset
                );
            }
            if (!this.state.isLoading) {
                this.addEvent({
                    event: "investmenttab_tableEditor",
                    tableEditor: {
                        targetAllocation: data[colEditorKey].some(
                            (ele) => ele?.Column == InvestmentsColumns.TargetAllocation && ele.Enabled
                        )
                            ? "yes"
                            : "no",
                        fundCode: data[colEditorKey].some(
                            (ele) => ele?.Column == InvestmentsColumns.FundCode && ele.Enabled
                        )
                            ? "yes"
                            : "no",
                        Location: data[colEditorKey].some(
                            (ele) => ele?.Column == InvestmentsColumns.Location && ele.Enabled
                        )
                            ? "yes"
                            : "no",
                        protectAssets: data[colEditorKey].some(
                            (ele) => ele?.Column == InvestmentsColumns.TreasuredAsset && ele.Enabled
                        )
                            ? "yes"
                            : "no",
                    },
                });
            }

            this.setState({ colsettings: data[colEditorKey] });
        }
    }

    onInvestmentStoreChange() {
        const data = InvestmentsStore.getData();
        data.data.map((x, product) =>
            x.ModelPortfolioInvestments.data.map((mpg) =>
                mpg.Investments.map((mp, index) =>
                    this.getModel(
                        mp.HubAccountIds.length == 0 ? [mp.InstrumentCode] : mp.HubAccountIds,
                        index,
                        product,
                        mp.InstrumentCode
                    )
                )
            )
        );
        if (data)
        {
            this.fetchCashProductDetails(data);
            this.setState({ data, isLoading: false });
        }
    }

    fetchCashProductDetails(data: IInvestmentTableData): void
    {
        const flatten = array =>
            array.reduce(
                (flattened, elem) =>
                    flattened.concat(Array.isArray(elem) ? flatten(elem) : elem),
                []
            );

        const cashProductIds: number[] = Array.from(
            new Set(flatten(data
                .data
                .map(x => x.IndividualInvestments.data.map(x => x.Investments)))
                .filter(row => row.Type === ProductType.CashProduct)
                .map(row => row.ProductId))
        );

        if (cashProductIds.length === 0)
        {
            return;
        }

        const accounts = PortfolioDashboardStore.getData();

        const servicePropositionId = accounts[0].AccountServicePropositionId;

        const query: DepositProductsQuery =
            {
                ProductIds: cashProductIds,
                ServiceProposition: servicePropositionId,
                ResultsPerPage: cashProductIds.length
            };

        InvestmentSelectionAction.searchDepositProducts(
            query,
            getQueryParameters()["hierarchyId"],
            (data: ResultPageModel<DepositProduct>) =>
            {
                const cashProducts: Record<number, DepositProduct> = data.Results
                    .reduce<Record<number, DepositProduct>>(
                        (acc, product) =>
                        {
                            acc[product.ProductId] = product;
                            return acc;
                        },
                        {})

                this.setState({ cashProducts: cashProducts });
            },
            (err) =>
            {
                console.error("Failed to fetch deposit products:", err);
            });
    }

    private defaultFilter() {
        return { view: ViewType.Product, tier: AssetClassType.Tier1 };
    }

    initState() {
        const now = new Date();
        this.state =
            {
                userInfo: UserStore.getUserInfo(),
                tier: AssetClassType.Tier1,
                asAt: new Date(now.getFullYear(), now.getMonth(), now.getDate()),
                view: ViewType.Product,
                data: null,
                isLoading: true,
                isOpenFilter: false,
                toggleFilter: new Object(),
                filter: this.defaultFilter(),
                colsettings: null,
                accountViewSelected: [],
                cashProducts: {}
            };
    }

    getData(selectedSubAccountHierarchyIds: string[]) {
        this.setState({
            accountViewSelected: selectedSubAccountHierarchyIds,
        });
        const colEditorKey = TableColSettingKeys.Investments;
        TableColSettingsAction.get(colEditorKey);

        const { asAt, tier, view } = this.state;
        this.setState({ isLoading: true });

        InvestmentsAction.getInvestments(
            selectedSubAccountHierarchyIds,
            JsonDateParser.toJsonDateNoOffset(asAt),
            tier,
            view
        );
    }

    private onApplyClick() {
        const { accountViewSelected } = this.state;
        this.state.toggleFilter(true);
        this.setState(
            (preState) => {
                return { tier: preState.filter.tier, view: preState.filter.view };
            },
            () => this.getData(accountViewSelected)
        );
    }

    private getModel(instrumentCode: Array<string>, index: number, product: number, modelId: string) {
        const { asAt, tier } = this.state;
        InvestmentsAction.getInvestmentsModel(
            instrumentCode,
            JsonDateParser.toJsonDateNoOffset(asAt),
            tier,
            index,
            product,
            null,
            modelId
        );
    }

    renderTable() {
        const { data, isLoading, asAt, tier, view, colsettings } = this.state;
        return (
            <LoadingSkeletonWrapper isLoading={isLoading || !colsettings} skeletonType={LoadingSkeletonType.Table}>
                <InvestmentTable
                    data={data}
                    asAt={asAt}
                    assetClassType={tier}
                    isAssetView={view == ViewType.Asset}
                    cols={colsettings}
                    onChange={(data) => this.setState({ data: data })}
                    cashProducts={this.state.cashProducts}
                />
            </LoadingSkeletonWrapper>
        );
    }

    private handleLaunchpadClick() {
        const context: Record<string, string> = {};

        const customerHierarchyId = ContextStore.getUrlParamsHierarchyId(ContextType.Customer);
        if (customerHierarchyId) {context.customerId = customerHierarchyId;}

        (window as any).AppStore.open(context);
    }

    private addEvent = new AdviserSiteTagManager().addEvent;

    public render(): JSX.Element {
        const { data, asAt, filter, tier, view, accountViewSelected } = this.state;
        const { isPresentationView } = this.context;
        const drillDownModelList: Array<number> = [];
        if (data) {
            data.data.map((product) => {
                product.ModelPortfolioInvestments.data.map((model) => {
                    model.Investments.map((item) => {
                        drillDownModelList.push(Number(item.InstrumentCode));
                    });
                });
            });
        }

        const isAppStoreEnabled = this.state.userInfo?.IsAppStoreEnabledForUser;

        return (
            <div role={isPresentationView ? "main" : "tabpanel"} id="panel-1" tabIndex={0} aria-labelledby="tab-1">
                <div className="ad d1">
                    <div className="row">
                        <div className="col-12 col-sm-fluid col-max-245">
                            <AsAtDatePicker
                                selected={asAt}
                                accountViewSelected={null}
                                onChange={(d) => {
                                    this.addEvent({
                                        event: "investmentstab_interaction",
                                        eventParameters: {
                                            eventCategory: eventCategoryForGTM.investmentsTab,
                                            eventAction: "interactions",
                                            eventLabel: "date widget",
                                        },
                                    });
                                    this.setState({ asAt: d }, () => this.getData(accountViewSelected));
                                }}
                                cssWrapper="label-sr-only form-group"
                            />
                        </div>
                        {this.renderToolBar() ? (
                            <div className="col-fluid col-bottom">
                                <div className="row row-right mb-12">
                                    {!isPresentationView && (
                                        <div className="col-auto">
                                            <ExcelExportButton
                                                onRequestReport={() => {
                                                    this.addEvent({
                                                        event: "investmentstab_interaction",
                                                        eventParameters: {
                                                            eventCategory: eventCategoryForGTM.investmentsTab,
                                                            eventAction: "interactions",
                                                            eventLabel: "export to excel",
                                                        },
                                                    });
                                                    return ExcelExportAction.generateInvestmentReport(
                                                        accountViewSelected,
                                                        asAt,
                                                        tier,
                                                        view,
                                                        drillDownModelList,
                                                        Number(
                                                            ContextStore.getUrlParamsHierarchyId(
                                                                ContextType.Customer
                                                            )?.split("-")[1]
                                                        )
                                                    );
                                                }}
                                                selectedAccount={null}
                                            ></ExcelExportButton>
                                        </div>
                                    )}
                                    <div className="col-auto pr-26">
                                        {/* <CoachMarker coachMarkerKey="investment-filter" /> */}
                                        <TableFilterDropdown
                                            cssWrapper="table-default-filter"
                                            labelSrOnly="Open the table filter dropdown"
                                            onOpen={(e) => this.setState({ toggleFilter: e })}
                                            title="Filter table"
                                            event={{
                                                event: "investmentstab_interaction",
                                                eventParameters: {
                                                    eventCategory: eventCategoryForGTM.investmentsTab,
                                                    eventAction: "interactions",
                                                    eventLabel: "filter click",
                                                },
                                            }}
                                        >
                                            <div>
                                                <RadiosEditor
                                                    cssWrapper="rg-100 mb-10 text-link"
                                                    label="Filter table by"
                                                    labelGridClasses="text-size-16 text-bold mb-10 text-text"
                                                    options={ViewTypeArray}
                                                    getText={(v) => {
                                                        return ViewTypeMap[v];
                                                    }}
                                                    selected={filter.view}
                                                    onChange={(v) =>
                                                        this.setState((preState) => {
                                                            return { filter: { tier: preState.filter.tier, view: v } };
                                                        })
                                                    }
                                                />
                                                <RadiosEditor
                                                    cssWrapper="rg-100 mb-20 text-link"
                                                    options={AssetClassTypeArray}
                                                    getText={(v) => {
                                                        return AssetClassTypeMap[v];
                                                    }}
                                                    selected={filter.tier}
                                                    onChange={(v) =>
                                                        this.setState((preState) => {
                                                            return { filter: { view: preState.filter.view, tier: v } };
                                                        })
                                                    }
                                                />
                                                <div className="row narrow-gutter">
                                                    <div
                                                        className="col-fluid text-right"
                                                        onClick={() => {
                                                            this.setState({ filter: this.defaultFilter() });
                                                            this.state.toggleFilter(true);
                                                        }}
                                                    >
                                                        <button className="btn secondary block-xxs">Cancel</button>
                                                    </div>
                                                    <div
                                                        className="col-auto"
                                                        onClick={() => {
                                                            this.addEvent({
                                                                event: "investmentstab_tablefilter",
                                                                filter: {
                                                                    type: ViewTypeMap[
                                                                        this.state.filter.view
                                                                    ].toLowerCase(),
                                                                    tier: AssetClassTypeMap[
                                                                        this.state.filter.tier
                                                                    ].toLowerCase(),
                                                                },
                                                            });
                                                            this.onApplyClick();
                                                        }}
                                                    >
                                                        <button className="btn primary block-xxs">Apply</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </TableFilterDropdown>
                                    </div>
                                    <div className="col-auto pr-26">
                                        {/* <CoachMarker coachMarkerKey="investment-table-editor" /> */}
                                        <TableColEditor
                                            tableEditorKey={TableColSettingKeys.Investments}
                                            col={InvestmentsColConfig()}
                                            disableDrag={true}
                                            title="Table editor"
                                            event={{
                                                event: "investmentstab_interaction",
                                                eventParameters: {
                                                    eventCategory: eventCategoryForGTM.investmentsTab,
                                                    eventAction: "interactions",
                                                    eventLabel: "table editor",
                                                },
                                            }}
                                        />
                                    </div>
                                    <div className="col-auto pr-26">
                                        <PresentationViewButton
                                            onClick={() => {
                                                this.addEvent({
                                                    event: "investmentstab_interaction",
                                                    eventParameters: {
                                                        eventCategory: eventCategoryForGTM.investmentsTab,
                                                        eventAction: "interactions",
                                                        eventLabel: "presentation mode",
                                                    },
                                                });
                                                this.props.onPresentationViewStatusChange(
                                                    portfolioDashboardTabEnum.Investments,
                                                    this.props.isBtnPresentationClicked
                                                );
                                            }}
                                        />
                                    </div>
                                    {isAppStoreEnabled && (
                                        <div className="col-auto pr-26">
                                            <button
                                                type="button"
                                                className="applications-pad-button"
                                                onClick={this.handleLaunchpadClick.bind(this)}
                                            >
                                                <span className="icon" aria-hidden="true"></span>
                                                <span className="sr-only">Applications pad</span>
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ) : null}
                    </div>
                    <div className="row mb-48">
                        <div className="col-12">{this.renderTable()}</div>
                    </div>
                </div>
            </div>
        );
    }

    private renderToolBar() {
        const { data } = this.state;
        if (!data || data.data.length == 0) {
            return false;
        } else {
            let sum = 0;
            data.data.map((product) => {
                sum = sum + product.total.Allocation;
            });

            if (sum == 0) {
                return false;
            }
        }

        return true;
    }
}
PortfolioDashboardInvestment.contextType = PresentationContext;
